// cubehelix interpolation
// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
// http://astron-soc.in/bulletin/11June/289392011.pdf
import { type, clip_rgb, TWOPI } from '../utils/index.js';
import chroma from '../chroma.js';
var pow = Math.pow,
  sin = Math.sin,
  cos = Math.cos;
export default function () {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  var rotations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1.5;
  var hue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var gamma = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var lightness = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [0, 1];
  var dh = 0,
    dl;
  if (type(lightness) === 'array') {
    dl = lightness[1] - lightness[0];
  } else {
    dl = 0;
    lightness = [lightness, lightness];
  }
  var f = function f(fract) {
    var a = TWOPI * ((start + 120) / 360 + rotations * fract);
    var l = pow(lightness[0] + dl * fract, gamma);
    var h = dh !== 0 ? hue[0] + fract * dh : hue;
    var amp = h * l * (1 - l) / 2;
    var cos_a = cos(a);
    var sin_a = sin(a);
    var r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
    var g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
    var b = l + amp * (+1.97294 * cos_a);
    return chroma(clip_rgb([r * 255, g * 255, b * 255, 1]));
  };
  f.start = function (s) {
    if (s == null) {
      return start;
    }
    start = s;
    return f;
  };
  f.rotations = function (r) {
    if (r == null) {
      return rotations;
    }
    rotations = r;
    return f;
  };
  f.gamma = function (g) {
    if (g == null) {
      return gamma;
    }
    gamma = g;
    return f;
  };
  f.hue = function (h) {
    if (h == null) {
      return hue;
    }
    hue = h;
    if (type(hue) === 'array') {
      dh = hue[1] - hue[0];
      if (dh === 0) {
        hue = hue[1];
      }
    } else {
      dh = 0;
    }
    return f;
  };
  f.lightness = function (h) {
    if (h == null) {
      return lightness;
    }
    if (type(h) === 'array') {
      lightness = h;
      dl = h[1] - h[0];
    } else {
      lightness = [h, h];
      dl = 0;
    }
    return f;
  };
  f.scale = function () {
    return chroma.scale(f);
  };
  f.hue(hue);
  return f;
}